import React, { useState, useEffect } from "react";
import TableSearchInput from "./TableSearchInput";

const CustomerSearchInput = ({ updateSearchValue, searchInput = "" }) => {
  const [inputValue, setInputValue] = useState("");

  useEffect(() => {
    if (!searchInput) {
      setInputValue("");
    }
  }, [searchInput]);

  const handleSearchChange = (event) => {
    const value = event.target.value;
    setInputValue(value);

    if (!value.trim()) {
      updateSearchValue("", { type: "query" });
      return;
    }

    updateSearchValue(value, { type: "query" });
  };

  return (
    <div className="search-row" style={{ width: 440 }}>
      <TableSearchInput
        searchQuery={inputValue}
        onSearchChange={handleSearchChange}
        tooltip="Search by Customer Code, Name or Phone No"
        placeholder="Search by Customer Code, Name or Phone No"
        fullWidth={false}
      />
    </div>
  );
};

export default CustomerSearchInput;
